































































































import { Component, Vue } from 'vue-property-decorator';
import { loadView } from '@/utils/helpers';
import SideBarDrawer from '@/views/SideBarDrawer.vue';
import { Getter, namespace } from 'vuex-class';
import { ISideBar, IUser } from '@/types/types';

const authModule = namespace('auth');
const navigationModule = namespace('navigation');
@Component({
  components: {
    SideBarDrawer,
    'app--drawer': loadView(`SideBar`),
  },
})
export default class Master extends Vue {
  @Getter('getNavigationDrawerState') drawerState!: boolean;
  @authModule.Getter('getUserType') userType!: string;
  @authModule.Getter('getUserDetails') user!: IUser;
  @navigationModule.Getter('getNavigationLinks') links!: Array<ISideBar | { label: string }>;
  @navigationModule.Getter('getNavigationKey') navigationKey!: string;
  state: boolean = true;
  menu: boolean = false;

  get initials(): string {
    const name = (this.user && this.user.name) || '';
    const parts = name
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return 'KA';
    return parts
      .slice(0, 2)
      .map(part => part[0].toUpperCase())
      .join('');
  }

  emitDrawer(value: boolean) {
    this.state = value;
  }

  closeDrawer(state: boolean) {
    this.$store.dispatch('navigationDrawer', state, { root: true });
  }
  signOut() {
    this.$store.dispatch('auth/logOut', null);
  }

  created(): void {
    // Resolve the sidebar section from the route so deep links and reloads
    // rebuild links from source — navigation.all is persisted to localStorage
    // and would otherwise show a stale sidebar after a deploy.
    const section = String(this.$route.name || '').split('.')[0];
    this.$store.dispatch('navigation/setAppLinks', section === 'cu' || section === 'sms' ? section : 'home');
    this.$store.dispatch('auth/me');
  }
}
